import {AbstractSystemPermission} from "./AbstractSystemPermission";
import {ISubmitDataOverride, TSystemPermissionStatus} from "./index";
import {IObjectData, ISystemPermission} from "../../../index";
import {Organization} from "./Organization";

export class Manual extends AbstractSystemPermission {
    protected isOverrideable: boolean = false;

    constructor(o: Organization, user: IObjectData | null, sp: ISystemPermission) {
        super(o, user, sp);
        this.init();
    }

    protected override init(): void {
        super.init();
        this.isDeleted(false);
        this.initData();
    }

    getStatus(): TSystemPermissionStatus {
        if (!this.sp.id) {
            return 'new';
        }

        if (this.isDeleted()) {
            return 'deleted';
        }

        if (this.isPropertiesChanged()) {
            return 'changed';
        }

        return 'unchanged';
    }

    containsNewOverrides(): boolean {
        return false;
    }

    delete() {
        this.isDeleted(true);
        if (!this.sp.id) {
            this.org.deleteManual(this);
        }
    }

    restore() {
        this.isDeleted(false);
        this.initData();
    }

    getSubmitDataOverride(): ISubmitDataOverride | null {
        return null;
    }

}
